import { render } from "./FilterSalesKAM.vue?vue&type=template&id=35ba260f"
import script from "./FilterSalesKAM.vue?vue&type=script&lang=js"
export * from "./FilterSalesKAM.vue?vue&type=script&lang=js"
script.render = render

export default script